import Immutable from 'immutable';
import { combineReducers } from 'redux-immutablejs';

import feedback from './FeedbackReducer';
import itemTransactions from './ItemTransactionReducer';
import itemLevelHold from './ItemLevelHoldReducer';
import listPresentation from './ListPresentationReducer';
import messaging from './MessagingReducer';
import progressBar from './ProgressBarReducer';
import savedSearch from './SavedSearchReducer';
import stackmap from './StackMapReducer';
import notices from './NoticesReducer';
import workflow from './WorkflowReducer';
import groupSearchFeedback from './GroupSearchFeedbackReducer';
import accountMessages from './AccountMessagesReducer';

export default combineReducers(
  Immutable.Map({
    feedback,
    itemTransactions,
    workflow,
    messaging,
    listPresentation,
    progressBar,
    savedSearch,
    stackmap,
    notices,
    groupSearchFeedback,
    itemLevelHold,
    accountMessages
  })
);



// WEBPACK FOOTER //
// ./app/reducers/ui/index.js